import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@wellesley/ui'
import { DAY, HOUR, MINUTE } from 'constants/date'
import { FC } from 'react'

const TIME_OPTIONS = [
  { value: (MINUTE * 5) / 1000, label: '5 minutes' },
  { value: (MINUTE * 30) / 1000, label: '30 minutes' },
  { value: HOUR / 1000, label: '1 hour' },
  { value: (HOUR * 6) / 1000, label: '6 hours' },
  { value: (HOUR * 12) / 1000, label: '12 hours' },
  { value: DAY / 1000, label: '1 day' },
  { value: (DAY * 3) / 1000, label: '3 days' },
  { value: (DAY * 7) / 1000, label: '7 days' },
  { value: 0, label: 'Non-expired' },
]

type PollTimeSelectProps = {
  value: number
  onChange: (value: string) => void
}

const PollTimeSelect: FC<PollTimeSelectProps> = ({ value, onChange }) => {
  return (
    <div className="[&>div]:!w-[auto]">
      <Select value={`${value}`} onValueChange={(value) => onChange(value)}>
        <SelectTrigger className="!p-none !h-auto !border-none text-base text-gray-500">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TIME_OPTIONS.map(({ value, label }) => (
            <SelectItem key={value} value={value.toString()}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default PollTimeSelect
